import { render, staticRenderFns } from "./VisualizarPerfilDialog.vue?vue&type=template&id=323c9ebb&scoped=true"
import script from "./VisualizarPerfilDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarPerfilDialog.vue?vue&type=script&lang=js"
import style0 from "./VisualizarPerfilDialog.vue?vue&type=style&index=0&id=323c9ebb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323c9ebb",
  null
  
)

export default component.exports